import { Controller } from "@hotwired/stimulus"

// Zusatzfrage: Antwortmöglichkeiten als dynamische Zeilen
export default class extends Controller {
  static targets = ["list", "template"]

  // [+] weitere Antwort hinzufügen
  add() {
    const last = this.listTarget.lastElementChild
    const lastInput = last?.querySelector("input")

    // Leere letzte Zeile wiederverwenden statt eine weitere anzuhängen
    if (lastInput?.value.trim() === "") return lastInput.focus()

    this.#insertAfter(last).focus()
  }

  // [×] Zeile löschen
  remove(event) {
    this.#removeRow(event.target.closest("li"))
  }

  // Enter = Zeile teilen, Backspace am Zeilenanfang = mit vorheriger Zeile zusammenführen,
  // Entf am Zeilenende = nächste Zeile heraufholen
  keydown(event) {
    const input = event.target
    const row = input.closest("li")
    const {selectionStart: start, selectionEnd: end} = input
    const noSelection = start === end

    if (event.key === "Enter") {
      event.preventDefault() // nie absenden

      const text = input.value

      // Leere Zeile: nichts tun (keine Leerzeilen-Ketten)
      if (text.trim() === "") return

      // Cursor ganz vorne → leere Zeile darüber
      if (start === 0) {
        const newInput = this.#insertAfter(row.previousElementSibling, "")
        return newInput.focus()
      }

      // Sonst: Text am Cursor teilen (Markierung wird ersetzt), Rest in neue Zeile darunter
      input.value = text.slice(0, start).trimEnd()
      const newInput = this.#insertAfter(row, text.slice(end).trimStart())
      newInput.focus()
      newInput.setSelectionRange(0, 0)
      return
    }

    // Backspace am Zeilenanfang (ohne Markierung)
    if (event.key === "Backspace" && noSelection && start === 0) {
      const prev = row.previousElementSibling
      if (prev) {
        event.preventDefault()
        return this.#merge(prev, row)
      }
      // Erste Zeile, leer → entfernen, Fokus auf nächste
      if (input.value === "" && this.listTarget.children.length > 1) {
        event.preventDefault()
        return this.#removeRow(row)
      }
      return
    }

    // Entf am Zeilenende (ohne Markierung)
    if (event.key === "Delete" && noSelection && start === input.value.length) {
      const next = row.nextElementSibling
      if (next) {
        event.preventDefault()
        this.#merge(row, next)
      }
    }
  }

  // Mehrzeiliger Text einfügen → eine Zeile pro Antwort
  paste(event) {
    const lines = event.clipboardData.getData("text")
      .split(/\r?\n/).map(s => s.trim()).filter(Boolean)
    if (lines.length < 2) return

    event.preventDefault()
    const input = event.target
    let row = input.closest("li")

    if (input.value.trim() === "") input.value = lines.shift()
    lines.forEach(line => {
      row = this.#insertAfter(row, line).closest("li")
    })
  }

  // --- private ---

  #insertAfter(row, value = "") {
    const newRow = this.templateTarget.content.firstElementChild.cloneNode(true)
    const input = newRow.querySelector("input")
    input.value = value
    row ? row.after(newRow) : this.listTarget.prepend(newRow)
    return input
  }

  // Text von sourceRow an targetRow anhängen, sourceRow entfernen, Cursor an die Nahtstelle
  #merge(targetRow, sourceRow) {
    const target = targetRow.querySelector("input")
    const source = sourceRow.querySelector("input")
    const pos = target.value.length

    target.value += source.value
    sourceRow.remove()

    target.focus()
    target.setSelectionRange(pos, pos)
  }

  #removeRow(row) {
    // Letzte Zeile nie entfernen, nur leeren
    if (this.listTarget.children.length === 1) {
      const input = row.querySelector("input")
      input.value = ""
      return input.focus()
    }

    const neighbour = row.previousElementSibling ?? row.nextElementSibling
    row.remove()

    // Cursor ans Textende der Nachbarzeile
    const input = neighbour.querySelector("input")
    input.focus()
    input.setSelectionRange(input.value.length, input.value.length)
  }
}
